import type { PropertyData } from "libs/codegen/property-onboarding";
import { useWatch } from "react-hook-form";
import { ContractPropertyCard } from "./ContractPropertyCard";

export const PropertyOverview = () => {
    const propertyPhoto = useWatch<PropertyData>({
        name: "photos.0.src",
    }) as string;
    const propertyName = useWatch<PropertyData>({
        name: "propertyName",
    }) as string;
    const stateName = useWatch<PropertyData>({
        name: "state.name",
    }) as string;
    const cityName = useWatch<PropertyData>({
        name: "city.name",
    }) as string;

    return <ContractPropertyCard name={propertyName} photo={propertyPhoto} location={`${cityName}, ${stateName}`} />;
};
